import { FC, useEffect, useState } from 'react';
import { IStudent } from '../../../../models/students.model';

import StudentName from '../Name';
import Loader from '../../../Loader';
import useAxios from '../../../../hooks/useAxios';
import { getStudentClasses } from '../../../../api/studentsClass.api';
import { IGetStudentClasses } from '../../../../models/studentsClass.model';
import ErrorResponse from '../../../ErrorResponse';
import {
  IClassAssignmentQuery,
  IGetClassAssignment,
} from '../../../../models/campusClasses.model';
import { getClassesAssignment } from '../../../../api/campusClasses.api';
import {
  IGetSemesterCourses,
  IGetSemesters,
} from '../../../../models/semesters.model';
import {
  getSemesterCourses,
  getSemesters,
} from '../../../../api/semesters.api';
import ClassAssignmentContents from './ClassAssignmentContents';
import { createStudent } from '../../../../api/campusClasses2.api';
import ClassCompleteContents from './ClassCompleteContents';
import ClassDefaultContents from './ClassDefaultContents';

interface IProps {
  student?: IStudent;
  onTabChange(tabIndex: number): void;
  doGetStudentClassInfo: () => void;
}

export enum Contents {
  default,
  assignment,
  complete,
}

const StudentClass: FC<IProps> = ({
  student,
  onTabChange,
  doGetStudentClassInfo,
}) => {
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetStudentClasses>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetClassAssignment>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetSemesters>();
  const {
    data: res4,
    isLoading: isLoading4,
    error: error4,
    execute: execute4,
  } = useAxios<IGetSemesterCourses>();
  const {
    data: createRes,
    isLoading: createIsLoading,
    error: createError,
    execute: createExecute,
  } = useAxios();

  const [contents, setContents] = useState<Contents>(Contents.default);

  useEffect(() => {
    doGetStudentClasses();
    setContents(Contents.default);
  }, [student]);

  useEffect(() => {
    if (createRes && !createIsLoading) {
      doGetStudentClasses();
      setContents(Contents.complete);
    }
  }, [createRes, createIsLoading]);

  const doGetStudentClasses = () => {
    if (student) {
      execute(getStudentClasses(student.studentCode));
    }
  };

  const onAssignmentClick = () => {
    if (student) {
      execute3(getSemesters());
    }
    setContents(Contents.assignment);
  };

  const doGetSemesterCourses = (semesterCode: string) =>
    execute4(getSemesterCourses(semesterCode));

  const onSearch = (params?: IClassAssignmentQuery) => {
    if (student) {
      execute2(getClassesAssignment(student.campusCode, params));
    }
  };

  const onSubmit = (classCode: string, studySrtDate: string, timetableCode: number) => {
    student &&
      createExecute(
        createStudent(classCode, {
          studentCode: student.studentCode,
          studySrtDate,
          srtTimetableCode: timetableCode,
        }),
      );
  };

  const renderContent = () => {
    switch (contents) {
      case Contents.default:
        return (
          <ClassDefaultContents
            data={res?.data}
            student={student}
            onAssignmentClick={onAssignmentClick}
          />
        );
      case Contents.assignment:
        return (
          <ClassAssignmentContents
            data={res2?.data}
            semesterList={res3?.data}
            semesterCourseList={res4?.data}
            onSearch={onSearch}
            onSubmit={onSubmit}
            doGetSemesterCourses={doGetSemesterCourses}
            setContents={setContents}
          />
        );
      case Contents.complete:
        return (
          <ClassCompleteContents
            goStudentInfo={() => onTabChange(0)}
            goAcceptance={() => onTabChange(3)}
            doGetStudentClassInfo={doGetStudentClassInfo}
          />
        );
    }
  };

  return (
    <>
      {(isLoading ||
        isLoading2 ||
        isLoading3 ||
        isLoading4 ||
        createIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={createError} />
      <StudentName student={student} />
      {renderContent()}
    </>
  );
};

export default StudentClass;
